export function maskString(item: string, isUrl?: boolean): string | undefined {
	if (!item) return;
	if (isUrl) return item.split('.com/oauth2/')[0];
	return `${item.slice(0, 3)}******${item.slice(-3)}`;
}
